/* eslint-disable */
import { extendDecorator, viewModelDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import template from './template.html';

@extendDecorator({
    events: {
        'click': 'toggleRestTypeFilter',
    },
    bindings: {
        '.js-tourFilter__item': 'classes:{ active: active }',
    },
    el: '<li class="js-tourFilter__item"></li>',
})
@viewModelDecorator({
    defaults: {
        active: false,
    },
})
export default class RestTypesView extends Backbone.Epoxy.View {
    initialize(options) {
        this.collectionView = options.collectionView;

        this.initModels();
        this.render();
    }

    initModels() {
        this.collectionView.model.on('change:selectedRestType', this.restTypeFilterChanged.bind(this));
    }

    render() {
        const jsonData = this.model.toJSON({ computeds: true });
        const isRestTypeAvailable = !_.isEmpty(this.collectionView.model.get('restTypesCount')) && jsonData.id;

        jsonData.count = isRestTypeAvailable
            ? this.collectionView.model.get('restTypesCount')[jsonData.id]
            : 0;

        this.$el.html(template(jsonData));

        if (!jsonData.count > 0) {
            this.$el.hide();
        }
    }

    restTypeFilterChanged() {
        const currentRestType = this.collectionView.model.get('selectedRestType');

        if (currentRestType === this.model) {
            this.viewModel.set('active', true);
            return;
        }

        this.viewModel.set('active', false);
    }

    toggleRestTypeFilter() {
        const currentRestType = this.collectionView.model.get('selectedRestType');
        if (currentRestType === this.model) {
            this.collectionView.model.set('selectedRestType', null);
            return;
        }

        this.collectionView.model.set('selectedRestType', this.model);
    }
}
